import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ANALYTICS_DIALOGS } from '../../../constants/analytics';
import { SET_DIALOG } from '../../../store/reducers/analytics';
import history from '../../../utils/history';

import Button from '../../common/Button';
import Modal from '../../common/Modal';

import styles from './ReportTable.module.scss';

export function SendReportNotificationDialog({ reportType }) {
  const isOpen = useSelector((state) => state.analytics.ui.dialog[ANALYTICS_DIALOGS.SEND_REPORT_NOTIFICATION]);
  const dispatch = useDispatch();
  const { supplierId } = useSelector((state) => state.role);

  const closeDialog = () => {
    dispatch({ type: SET_DIALOG, payload: { dialogId: ANALYTICS_DIALOGS.SEND_REPORT_NOTIFICATION, isOpen: false } });
  };

  useEffect(() => {
    return () => closeDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal open={isOpen} onClose={closeDialog} showCloseIcon center>
      <div className={styles.reportSentDialog}>
        <div className={styles.content}>
          Your {reportType} report is being emailed to you and will
          <br />
          soon be available on the
          <button onClick={() => history.push(`/suppliers/${supplierId}/analytics/reports`)}>Reports page</button>
        </div>
        <div className={styles.footer}>
          <div className={styles.buttons}>
            <Button text="OK" onClick={closeDialog} />
          </div>
        </div>
      </div>
    </Modal>
  );
}
